module.exports = __webpack_public_path__ + "img/18.7328c996.png";